// client/src/utils/permissions.js

// NOTE: This object must be kept in sync with the backend's `server/permissions.js`
// NOTE: This object must be kept in sync with the backend's `server/permissions.js`
const permissions = {
    superadmin: ['all', 'superadmin:access_shops'],
    admin: [
        'records:create', 'records:view', 'records:edit', 'records:delete',
        'vehicles:create', 'vehicles:view', 'vehicles:edit', 'vehicles:delete',
        'stats:view',
        'settings:prices', 'settings:menus', 'settings:options', 'settings:sizes', 'settings:carmodels',
        'users:manage',
        'customer:create', 'customer:view', 'customer:edit', 'customer:adjustPoints', // Granular customer permissions
        'settings:shop',
    ],
    employee: [
        'records:create', 'records:view',
        'vehicles:create', 'vehicles:view',
        'customer:create', 'customer:view', 'customer:edit', // Employee can manage customers but not adjust points
    ],
};

const ROLE_LABELS = {
    superadmin: 'superadmin',
    admin: '관리자',
    employee: '직원',
};

export function getRoleLabel(role) {
    return ROLE_LABELS[role] || role;
}

/**
 * Checks if a user role has a specific permission.
 * @param {string} role - The user's role (e.g., 'admin', 'employee').
 * @param {string} requiredPermission - The permission to check for (e.g., 'records:edit').
 * @returns {boolean}
 */
export function hasPermission(role, requiredPermission) {
  if (!role) {
    return false;
  }
  if (role === 'superadmin') {
    return true;
  }

  const userPermissions = permissions[role] || [];
  
  if (userPermissions.includes(requiredPermission)) {
    return true;
  }

  const wildcardPermission = requiredPermission.split(':')[0] + ':*';
  if (userPermissions.includes(wildcardPermission)) {
    return true;
  }

  return false;
}